import { useTranslator } from '@Localization';
import { Button } from '@mui/joy';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { S_Modal } from '../../../../design/modals/modal/S_Modal';
import { EncryptedWarning } from '../../../../modules/decryption/EncryptedWarning';

interface IProps {
  newWorkspaceName: string;
  showKeyDownload: boolean;
  encryptionKeyUrl: string;
  toggleKeyDownload: () => void;
}

export const KeyDownloadModal = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();
  return (
    <S_Modal
      isOpen={props.showKeyDownload}
      toggle={props.toggleKeyDownload}
      headerText={t('key_download')}
      buttons={
        <>
          <Button
            variant='outlined'
            onClick={props.toggleKeyDownload}
          >
            {t('workspace_ok')}
          </Button>
          <a
            href={props.encryptionKeyUrl}
            download={`${props.newWorkspaceName}.key`}
          >
            <Button onClick={props.toggleKeyDownload}>{t('download_key')}</Button>
          </a>
        </>
      }
    >
      <p>{t('key_instruction')}</p>
      <p>
        <EncryptedWarning text={`${t('warning')}!`} /> {t('key_warning')}
      </p>
    </S_Modal>
  );
});
